module.exports = "https://static.zego.com/_next/static/images/icon-warning-mask-7cd392211275b8de5b8306e497c91b83.svg";